module.exports = __webpack_public_path__ + "static/media/006-linkedin.9b3d2c5a.svg";